export const SERVICE_OPTIONS = [
    { value: 'verilive', label: 'VeriLive', color: 'blue' },
    { value: 'veriface', label: 'VeriFace', color: 'green' },
    { value: 'veridoc', label: 'VeriDoc', color: 'orange' },
];

export const LICENSE_STATUS = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};

export const STATUS_COLORS = {
    [LICENSE_STATUS.ACTIVE]: 'green',
    [LICENSE_STATUS.EXPIRING]: 'orange',
    [LICENSE_STATUS.EXPIRED]: 'red'
};